import { navigateInShell } from '../../shell/navigation/rootNavigation';
import { useCatalogOverlayStore } from '../store/useCatalogOverlayStore';

type NavigationLike = {
  navigate: (route: string, params?: object) => void;
};

/** Cierra el flujo actual y abre Catálogo → Nuevo servicio. */
export function openCatalogNewService(navigation: NavigationLike): void {
  useCatalogOverlayStore.getState().requestOpenNewService();
  navigateInShell(navigation, 'Catalog');
}

/** Cierra el flujo actual y abre Catálogo → Cargar producto. */
export function openCatalogNewProduct(navigation: NavigationLike): void {
  useCatalogOverlayStore.getState().requestOpenNewProduct();
  navigateInShell(navigation, 'Catalog');
}

export type CatalogMastersSection = 'categories' | 'brands' | 'suppliers';

/**
 * Abre Catálogo → hub «Maestros» en la sección indicada.
 * Usado por Compras cuando una orden necesita un proveedor y no hay ninguno.
 */
export function openCatalogMasters(
  navigation: NavigationLike,
  section: CatalogMastersSection = 'suppliers',
): void {
  useCatalogOverlayStore.getState().requestOpenMasters(section);
  navigateInShell(navigation, 'Catalog');
}
